import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: Theme) => ({
  chevron: {
    "&:hover": {
      cursor: "pointer",
    },
    color: theme.palette.gray80.main,
  },
  leftChevron: {
    paddingTop: 2,
    paddingRight: 8,
  },
  rightChevron: {
    paddingTop: 2,
    paddingLeft: 8,
  },
  monthLabel: {
    textTransform: "capitalize",
    fontSize: "20px",
    letterSpacing: "0.15px",
    minWidth: 164,
    textAlign: "center",
    color: theme.palette.gray80.main,
  },
}));

export default useStyles;
